import React from 'react';
import '../Components/ComBan.css';
import { motion } from 'framer-motion';

export default function ComBan() {
  return (
    <div className="com-banner">
      <div className="container">
        <motion.div 
          className="com-banner-content"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <h1>Commercial <span>Landmarks</span></h1>
          <p>Engineering robust and modern commercial spaces for the business world.</p>
        </motion.div>
      </div>
    </div>
  );
}
